import { axiosRef } from '../../../api';
import { JobSummary, JobSummaryQueryPayload } from '../interfaces';

export default async function getJobSummary(
  payload: JobSummaryQueryPayload,
  setLoading: (loading: boolean) => void,
) {
  let url = '/job_summary?is_pagination=true&';

  if (payload && payload.search) {
    url += `search=${payload.search}&`;
  }
  if (payload && payload.page) {
    url += `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url += `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.projectCode) {
    url += `project_code=${payload.projectCode}`;
  }

  setLoading(true);
  try {
    const response = await axiosRef.get(url);

    if (!response?.data?.is_error) {
      setLoading(false);
      const jobSummary = response
        .data
        .content
        .data
        .map((datum: any): JobSummary => ({
          actualPickupDate: datum.actual_pickup_date,
          bbeNumber: datum.bbe_number,
          creationDate: datum.creation_date,
          description: datum.description,
          handoffLocation: datum.handoff_location,
          id: datum.id,
          initialPlannedPickupDate: datum.initial_planned_pickup_date,
          initialPlannedStagingDate: datum.initial_planned_staging_date,
          priorityName: datum.priority_name,
          purchaseOrder: datum.purchase_order,
          revisedPickupDate: datum.revised_pickup_date,
          revisedStagingDate: datum.revised_staging_date,
          statusName: datum.status_name,
          totalShipments: datum.total_shipments,
          totalWeight: datum.total_weight,
          travelModeName: datum.travel_mode_name,
          vendor: datum.vendor,
        }));
        return {
          jobSummary,
          count: response.data.content.count,
          current: response.data.content.current,
          pages: response.data.content.pages,
        };
    }
  } catch (error) {
    setLoading(false);
    return {
      jobSummary: [],
      count: 0,
      pages: 0,
      current: 0,
    };
  }
  setLoading(false);
    return {
      jobSummary: [],
      count: 0,
      pages: 0,
      current: 0,
    };
}
